import React from "react";
import { ToolsController } from "./ToolsController";
import { ToolsViewModel } from "./ToolsViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class ToolsProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new ToolsViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <ToolsController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Tools/ToolsProvider.js